import block from 'bem-cn-lite';
import 'components/ErrorReporter/index.scss';
import React, {Component, ErrorInfo, ReactElement} from 'react';

const b = block('ErrorReporter');

type Props = {
  handleGlobal: boolean;
  showTraceback: boolean;
  children: ReactElement;
};

type State = {
  error: PromiseRejectionEvent | ErrorEvent | ErrorMsg | null;
};

export class ErrorMsg extends Error {}

export default class ErrorReporter extends Component<Props, State> {
  static getDerivedStateFromError(error: Error) {
    return {error};
  }

  constructor(props: Props) {
    super(props);
    this.state = {error: null};
  }

  componentDidMount() {
    if (this.props.handleGlobal) {
      window.addEventListener('error', this.handler);
      window.addEventListener('unhandledrejection', this.handler);
    }
  }

  componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
    // console.log('ErrorReporter', error, errorInfo);
  }

  componentWillUnmount() {
    if (this.props.handleGlobal) {
      window.removeEventListener('error', this.handler);
      window.removeEventListener('unhandledrejection', this.handler);
    }
  }

  render() {
    const {error} = this.state;
    if (error) {
      let message = 'Неизвестная ошибка';
      let trace = null;
      if (error instanceof PromiseRejectionEvent) {
        trace = error.reason.stack;
        message = error.reason.message;
      } else {
        // @ts-ignore
        if (error.stack) {
          // @ts-ignore
          trace = error.stack;
        }
        if (error.message) {
          message = error.message;
        }
      }
      if (error instanceof ErrorMsg) {
        trace = null;
      }
      return (
        <div className={b()}>
          <div className={b('message')}>{message}</div>
          <div
            className={b('traceback')}
            style={{color: this.props.showTraceback ? 'black' : 'lightgray'}}
          >
            {trace}
          </div>
        </div>
      );
    }

    return this.props.children;
  }

  handler = (error: ErrorEvent | PromiseRejectionEvent) => {
    error.preventDefault();
    console.log(error);
    this.setState({error});
  };
}
